import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BRIEFING_FORM_VALUES } from '../util/api.endpoints';

@Injectable({
  providedIn: 'root'
})
export class BriefingFormValuesService {

  constructor(private http: HttpClient) { }

  getBriefingFormValues(): Observable<any> {
    return this.http.get(API_BRIEFING_FORM_VALUES);
  }

  getBriefingFormValuesById(id: string): Observable<any> {
    const url = `${API_BRIEFING_FORM_VALUES}/${id}`;
    return this.http.get<any>(url);
  }

  submitBriefingFormValuesWithSection(data: any): Observable<any> {
    return this.http.post(API_BRIEFING_FORM_VALUES, data);
  }

  submitBriefingFormValuesWithOutSection(data: any): Observable<any> {
    return this.http.post(API_BRIEFING_FORM_VALUES, data);
  }
}
